import { useAppStoreBase } from 'stores/app/app.store';

const updateHeartbeatTS = () => {
  useAppStoreBase.getState().actions.updateHeartbeatTS();
};

const updatePublicHeartbeatTS = () => {
  useAppStoreBase.getState().actions.updatePublicHeartbeatTS();
};

export { updateHeartbeatTS, updatePublicHeartbeatTS };
